import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Icon, Table, notification, Button } from 'antd';
import { REQUEST_GET_USER_CLAIMS } from '../../Redux/constants/constants';
import api from '../../Api/api';
import openErrorNotification from '../../Utils/openErrorNotification';
import translateStatus from '../../Utils/translateStatus';

const { Column } = Table;

const UserClaimsTable = ({ userId }) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.currentUserClaims);
  useEffect(() => {
    if (userId) {
      dispatch({
        type: REQUEST_GET_USER_CLAIMS,
        payload: userId,
      });
    }
  }, [userId]);

  const openNotification = () => {
    const args = {
      message: 'Nieprawidłowy zakres dat',
      description:
        'Daty we wniosku są już wykorzystane. Należy odrzucić obecny wniosek i stworzyć nowy wniosek z prawidłowym zakresem dat.',
      duration: 0,
    };
    notification.open(args);
  };

  const changeClaimStatus = (id, status) => {
    api
      .changeClaimStatus({ id, status, userId })
      .then((data) => {
        dispatch({
          type: REQUEST_GET_USER_CLAIMS,
          payload: userId,
        });
      })
      .catch((e) => {
        openErrorNotification(e);
      });
  };

  return (
    <Table pagination={false} rowKey={(record) => record.id} dataSource={data}>
      <Column title="Data" dataIndex="date" key="date" />
      <Column title="Typ" dataIndex="type" key="type" />
      <Column
        title="Status"
        dataIndex="status"
        key="status"
        render={(record) => translateStatus(record)}
      />
      <Column
        title=" "
        key="accept"
        render={(record) => (
          <Button
            type="link"
            disabled={record.status === 'accepted'}
            onClick={() => {
              changeClaimStatus(record.id, 'accepted');
            }}
          >
            <>
              <Icon type="like" />
              <span> Zaakceptuj</span>
            </>
          </Button>
        )}
      />
      <Column
        title=" "
        key="reject"
        render={(record) => (
          <Button
            type="link"
            onClick={() => {
              changeClaimStatus(record.id, 'rejected');
            }}
          >
            <>
              <Icon type="delete" />
              <span> Odrzuć</span>
            </>
          </Button>
        )}
      />
    </Table>
  );
};

export default UserClaimsTable;
